export default __webpack_public_path__ + "static/kamilak-57adf8fe9c5abc58af6c17d5c5d5aad4.webp";